import type { NodeEntry } from 'slate';

import { renderContentBlockFns } from './content-block';
import type { RenderModelFooter, RenderModelHeader } from '../../slate-api';
import type { RenderContext, RenderNodeFnsOf } from '../engine/render-context';
import type { BaseRenderNodeOptions } from '../engine/rendering-data';

export const renderHeaderFooterFns: RenderNodeFnsOf<
  RenderModelHeader | RenderModelFooter,
  BaseRenderNodeOptions
> = {
  'default-footer': renderHeaderOrFooter,
  'default-header': renderHeaderOrFooter,
  'even-footer': renderHeaderOrFooter,
  'even-header': renderHeaderOrFooter,
  'first-page-footer': renderHeaderOrFooter,
  'first-page-header': renderHeaderOrFooter,
};

export function renderHeaderOrFooter(
  renderContext: RenderContext,
  rMHeaderOrFooterEntry: NodeEntry<RenderModelHeader | RenderModelFooter>,
  options: BaseRenderNodeOptions
) {
  renderContext.renderChildren(rMHeaderOrFooterEntry, renderContentBlockFns, options);
}
